<template>
	<section
		v-editable="blok"
		class="container"
	>
		<div class="overflow-hidden relative rounded-2xl shadow-gray-md">
			<div class="relative z-10 flex max-lg:flex-col lg:items-center lg:gap-6 xl:gap-8">
				<div class="relative lg:pl-5 xl:pl-8 lg:self-stretch flex max-lg:justify-center lg:items-center max-lg:py-4">
					<NuxtIcon
						name="custom/confetti-sm"
						filled
						class="[&_svg]:!w-[10.125rem] [&_svg]:!h-auto absolute inset-0 hidden lg:block"
					/>
					<NuxtIcon
						name="custom/confetti"
						filled
						class="[&_svg]:!w-[19.375rem] [&_svg]:!h-auto absolute left-1/2 -translate-x-1/2 -translate-y-3 lg:hidden"
					/>
					<span class="bg-white size-24 flex items-center justify-center rounded-full">
						<NuxtIcon
							name="custom/30th-help"
							filled
							class="[&_svg]:!w-[3.6875rem] [&_svg]:!h-auto left-[.1875rem] relative"
						/>
					</span>
				</div>
				<div class="max-lg:text-center max-lg:flex max-lg:items-center max-lg:flex-col">
					<h3 class="typo-h4 mb-3 max-w-[18rem]">
						Díky, že jste svými nákupy přispěli na&nbsp;30 vozů pro <span class="sr-only">Konto Bariéry.</span>
					</h3>
					<NuxtImg
						src="/images/30th/kontobariery.png"
						alt=""
						class="max-lg:inline"
						width="241"
						height="26"
					/>
				</div>

				<div
					class="
						py-4 grow flex justify-center max-lg:relative
						after:absolute after:lg:right-1/2 max-lg:after:bottom-10 after:lg:top-1/2 after:lg:-translate-y-1/2 after:xl:w-[54rem] after:w-[44rem] after:h-[44rem] after:bg-brand-globus-orange after:rounded-full after:-z-1
					"
				>
					<NuxtImg
						src="/images/30th/30th-car.png"
						alt=""
						width="272"
						height="119"
						class="max-lg:max-w-[13.625rem] max-xl:max-w-[11rem]"
					/>
				</div>

				<div class="flex gap-4 max-lg:px-4 max-lg:pb-4 lg:pr-5 max-lg:flex-col xl:pr-8 lg:items-center lg:justify-end">
					<div class="text-center lg:text-right leading-4">
						<h4 class="typo-h1 text-red-800 !text-[2rem]">
							{{ blok.price }}
						</h4>
						<span class="text-xs text-body-quaternary">
							Aktualní příspěvek ke dni {{ format(new Date(blok.date), 'd. M. yyyy') }}
						</span>
					</div>
					<StoryblokComponent
						v-for="item in blok.cta"
						:key="item._uid"
						:blok="item"
						class="btn-primary btn-lg xl:ml-2 max-lg:justify-center text-base"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {format} from 'date-fns';
	import type {CampaignBannerStoryblok} from '@/storyblok/types';

	interface Props {
		blok: CampaignBannerStoryblok
	}

	defineProps<Props>();
</script>
